import api from '@pray/shared/utils/api';

/**
 * Clarification question type
 */
export type ClarifyQuestionType = 'single' | 'multiple' | 'text';

/**
 * Option for multi-choice questions
 */
export type ClarifyOption = {
  id: string;
  label: string;
};

/**
 * Clarification question from Solomon
 */
export type ClarifyQuestion = {
  id: string;
  text: string;
  type: ClarifyQuestionType;
  options?: ClarifyOption[];
  required: boolean;
};

/**
 * Response from clarification check endpoint
 */
export type ClarifyCheckResponse = {
  needsClarification: boolean;
  confidence: number;
  reason?: string;
  questions?: ClarifyQuestion[];
  skipReason?: string;
};

/**
 * Request parameters for clarification check
 */
export type CheckClarificationRequest = {
  prompt: string;
  slide_types: string[];
};

type CheckClarificationProps = {
  artistId: string;
  reportId: string;
  data: CheckClarificationRequest;
};

/**
 * Check if a report prompt needs clarification questions
 *
 * This endpoint uses Solomon AI to analyze the user's prompt
 * and determine if follow-up questions are needed before
 * generating the report.
 */
export async function checkClarification({
  artistId,
  reportId,
  data,
}: CheckClarificationProps): Promise<{ data: ClarifyCheckResponse }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}/clarify/check`;

  const response = await api.executePostRequest<{ data: ClarifyCheckResponse }>(url, data);
  return response.data;
}
